module.exports = __webpack_public_path__ + "44448976ce0a3c17bc312721bf07feed.svg";